import React from 'react';
import { INSTAGRAM_LINK, SUPPORT_EMAIL } from './Shared';
export function Footer() {
  return <footer className="border-t border-brand-gold/40 bg-brand-purpleDark py-12 text-white" data-id="element-87" data-mp="3gfsjo3v2keir">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-88" data-mp="32oe2m2kq2nec">
        <div className="mb-8" data-id="element-89" data-mp="32m1ef7odfgsu">
          <h3 className="mb-2 font-display text-3xl font-bold text-brand-goldLight" data-id="element-90" data-mp="36oo8zgcffftq">🔮 LUMEN AKASHA™</h3>
          <p className="text-white/80" data-id="element-91" data-mp="3ues8bbil0tex">
            El sistema profesional número uno para terapeutas en Gemoterapia Holística.
          </p>
          <p className="mt-2 text-white/70" data-id="element-92" data-mp="36mu4n8jl4u2">
            Porque aplicar Gemoterapia con excelencia no debería costarte la seguridad ni la rentabilidad de tu
            consultorio.
          </p>
        </div>
        <div className="mb-12 flex flex-col items-center justify-center gap-4 text-sm md:flex-row md:gap-7" data-id="element-93" data-mp="3qf9raqtvt2hd">
          <a className="transition-colors hover:text-brand-goldBright" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-94" data-mp="2ey9zdwbg4pnv">
            📧 {SUPPORT_EMAIL}
          </a>
          <a className="transition-colors hover:text-brand-goldBright" href={INSTAGRAM_LINK} data-id="element-95" data-mp="3labp9pa6nun7">
            📲 @lumen.akasha
          </a>
          <a className="transition-colors hover:text-brand-goldBright" href="https://www.lumenakasha.com" data-id="element-96" data-mp="3gctq2qlywtse">
            🌐 www.lumenakasha.com
          </a>
        </div>
        <div className="space-y-2 text-xs text-white/50" data-id="element-97" data-mp="3q724ybi2so83">
          <p data-id="element-98" data-mp="82ie9xijwigy">
            © Lumen Akasha™ 2025 — Todos los derechos reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <p data-id="element-99" data-mp="3230j4ucx8yg">
            Ley 25.326 — Protección de Datos Personales — República Argentina · Ley 11.723 — Propiedad Intelectual —
            República Argentina
          </p>
        </div>
        <p className="mt-8 font-serif text-sm italic text-brand-goldLight/85" data-id="element-100" data-mp="cvtlhzr9z19e">
          🔮 “La terapeuta que tiene un sistema trabaja con confianza. La que trabaja con confianza genera resultados. La
          que genera resultados crece.”
        </p>
      </div>
    </footer>;
}